import { render, staticRenderFns } from "./mainWorkList.vue?vue&type=template&id=0c4f35a2&"
import script from "./mainWorkList.vue?vue&type=script&lang=js&"
export * from "./mainWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports